import { useMemo } from 'react';
import { type ComputeCanSendArgs, computeCanSend } from '../utils/can-send';

export interface UseClawInputCanSendArgs extends ComputeCanSendArgs {}

/** 把 canSend 的判断收敛进 hook，方便在 ChatInput 里只关心结果。 */
export const useClawInputCanSend = (args: UseClawInputCanSendArgs): boolean => {
  const { disableSend, sending, uploadingFile, flushingBufferedDraft, messageContent, hasAttachments } = args;
  return useMemo(
    () =>
      computeCanSend({
        disableSend,
        sending,
        uploadingFile,
        flushingBufferedDraft,
        messageContent,
        hasAttachments,
      }),
    [disableSend, sending, uploadingFile, flushingBufferedDraft, messageContent, hasAttachments],
  );
};
